<template>
  <component
    :is="tag"
    :class="[
      'py-2 px-4 uppercase focus:outline-none transition inline-flex items-center justify-center',
      variantClasses[variant] || variantClasses['primary'],
      sizeClasses[size],
    ]"
    :to="to"
    :href="href"
    @click="$emit('click')"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "Button",
  props: {
    variant: {
      type: String,
      default: "primary", // Default variant is primary
    },
    size: {
      type: String,
      default: "md", // 'sm', 'md', 'lg'
    },
    to: [String, Object], // For vue-router
    href: String, // For regular links
    tag: {
      type: String,
      default: "button", // Default tag is button
    },
  },
  computed: {
    sizeClasses() {
      return {
        sm: "text-sm",
        md: "text-base px-4 py-2",
        lg: "text-lg",
      };
    },
    variantClasses() {
      return {
        primary: "bg-primary-1 text-white hover:bg-primary-2 hover-text-white",
        secondary: "bg-secondary-1 text-white hover:bg-white hover:text-secondary-1 hover:border-secondary-1 border-2	",
        // Add more variants as needed
      };
    },
  },
};
</script>
